// Regra de exibição do botão de ativar/desativar IA no cabeçalho da conversa.
//
// Vive aqui porque quem pergunta são dois: o botão (TicketActionButtons) e o aviso que
// substitui a barra de digitação quando a IA está atendendo (InputBloqueado, via Ticket).
// O aviso manda desativar a IA no cabeçalho, então ele precisa saber se o botão existe
// para aquele usuário — regra duplicada aqui daria aviso mandando clicar em nada.
//
// A condição é assimétrica: desligar exige só que a IA esteja ligada na conversa (inclusive
// em conexão que deixou de ser de IA); ligar exige URL da I.A. cadastrada na conexão, senão
// não há fluxo para onde entregar a conversa (a URL é por conexão, sem padrão global).
export const podeAlternarIa = (user, ticket) =>
	!!user?.renderBotaoIa
	&& ticket?.status !== "closed"
	&& !ticket?.isGroup
	&& !!(ticket?.atendimentoIa || ticket?.whatsapp?.urlIA);

export default podeAlternarIa;
